export default {
  negative: '#fe4a49',
  positive: '#16a34a',
  textPrimary: '#111827',
  textSecondary: '#6b7280',
  primaryButton: '#5fc6e0',
  secondaryButton: '#f1a98f',
  button: '#cbd5e1',
  backgroundPrimary: '#127CA6',
  backgroundSecondary: '#f3f4f6',
  primary: '0,99,154',
  onPrimary: '255,255,255',
  primaryContainer: '206,229,255',
  onPrimaryContainer: '0,29,50',
  secondary: '81,96,111',
  onSecondary: '255,255,255',
  secondaryContainer: '213,228,247',
  onSecondaryContainer: '14,29,42',
  tertiary: '104,88,122',
  onTertiary: '255,255,255',
  tertiaryContainer: '238,219,255',
  onTertiaryContainer: '35,21,51',
  error: '186,26,26',
  onError: '255,255,255',
  errorContainer: '255,218,214',
  onErrorContainer: '65,0,2',
  background: '252,252,255',
  onBackground: '26,28,30',
  surface: '252,252,255',
  onSurface: '26,28,30',
  surfaceVariant: '222,227,235',
  onSurfaceVariant: '66,71,78',
  outline: '114,119,127',
  outlineVariant: '194,199,207',
  shadow: '0,0,0',
  scrim: '0,0,0',
  inverseSurface: '47,48,51',
  inverseOnSurface: '240,240,244',
  inversePrimary: '150,204,255',
};
